require('./categories-form.scss')

module.exports = {
  template: require('./categories-form.pug')()
  controller: require('./categories-form.ctrl')
  bindings:
    category: '<'
    onSubmit: '&'
}
